<template>
  <div>
    <h2>Персональные данные</h2>
    <div class="left shedule-header">
      <h3 class="shedule-title">Очистка локальной копии персональных данных</h3>
    </div>
    <div>
      <div>
        <button class="button" @click="deleteLocalPersonalData">Очистить</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonalData',
  mounted() {
  },
  data() {
    return {
      error: null,
      disabled: false
    }
  },
  props: {

  },
  methods: {
    async deleteLocalPersonalData() {
      const removalConfirmed = confirm(
        `Вы уверены, что хотите очистить локальные копии персональных данных?`
      )

      if (!removalConfirmed) {
        return;
      }

      this.disabled = true

      await this.axios
        .delete('/uprid/personal-data')
        .catch((e) => {
          this.disabled = false
        })


      this.disabled = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PersonalData.vue?0aa3f5f8